const inputViewTimeActions = {
  placeholder: 'Write here...'
};

export default inputViewTimeActions;
